/* unplugin-vue-components disabled */import { render } from "./SalesClosedBanner.vue?vue&type=template&id=415618e9&scoped=true&ts=true"
import script from "./SalesClosedBanner.vue?vue&type=script&lang=ts"
export * from "./SalesClosedBanner.vue?vue&type=script&lang=ts"

import "./SalesClosedBanner.vue?vue&type=style&index=0&id=415618e9&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415618e9"]])

export default __exports__